import React, { useEffect, useState } from 'react'
import { Card, Image } from 'react-bootstrap';
import { Link, useLocation, useSearchParams, useNavigate } from 'react-router-dom';
import { Container, Col, Row, Button, ButtonGroup, ButtonToolbar, Table, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar, faClock } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import { serverurl } from '../../providers/ServerUrl';
import '../EventDetail.css';
import './Event.css';
import Slider from 'react-slick';

export const Event = () => {

  
    /********************************************
              GET THE FILE URLS
    *********************************************/
    //const eventfileurl = serverurl + "/admin/img/events/";

    /**********************************************
       GET THE EVENT AND EVENT GALLERY FROM THE API
     **********************************************/

       const [events, setEvents] = useState([]);
     
   
       const fetchEventsData = () => {
         return axios.get(serverurl+"/api/eventall")
             .then((response) => setEvents(response.data['events']));
       };
     
       useEffect(() => {
          fetchEventsData();
       },[]);

       const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,

   };

    // Create a MediaQuery object
    const y = window.matchMedia("(max-width: 767px)");

    const changeSize = (x) => {
        if(x.matches) { 
        settings.slidesToShow = 1
        } else {
        settings.slidesToShow = 3
        }
    }

    changeSize(y)

    // Attach listener function on state changes
    y.addEventListener("change", function() {
        changeSize(y);
    });



    return (
        <div>

            <div>
                <div style={{ position: 'relative' }}>
                    <Image fluid src="images/headerbanner.png" alt="Card image" id="bannerimg" />
                    <div id="banneroverlay">
                        <div id="bannerid" className='text-center'>
                            <h4>EVENTS</h4>
                        </div>
                    </div>
                </div>
            </div>

            <br></br><br></br>
            <Container className="py-5">
                <Row className="g-4">
                    {
                        events && events.length > 0 && events.map((eventData, index) => {
                            return (
                                <React.Fragment key={eventData.events_id || index}>
                                {eventData.events_title !== '' || eventData.events_enddate > eventData.datenow ?
                                     <Col lg={4} md={6} sm={12}>
                                         <div id="deptcard" className='event-modern-card'>
                                             <div className="event-card-img-container" id='eventimg'>
                                               <img src={eventData.events_file} alt={eventData.events_title} className="event-full-img" />
                                               {
                                               eventData.events_status ?
                                               <span className="event-ongoing-pill-floating">
                                                 <span className="ongoing-radar-dot"></span>
                                                 ONGOING
                                               </span> : null
                                               }
                                             </div>
                                             <div className="event-date-strip" id='eventtext'>
                                                <div className="event-date-badge">
                                                  <FontAwesomeIcon icon={faCalendar} className="me-2" style={{ color: '#f5a425' }} />
                                                  <span>{eventData.events_startdatemonth}</span>
                                                </div>
                                                {eventData.events_starttime ?
                                                  <div className="event-time-badge">
                                                    <FontAwesomeIcon icon={faClock} className="me-2" style={{ color: '#f5a425' }} />
                                                    <span>{eventData.events_starttime}</span>
                                                  </div> : null
                                                }
                                             </div>
                                             <div className='event-card-body text-center'>
                                                 <h5 id="bluecolor" className="event-title">{eventData.events_title}</h5>
                                                 <p style={{ color:'#555' }} className="event-desc">
                                                     { eventData.events_desc }
                                                 </p>
                                                 {
                                                 eventData.events_status ?
                                                 <div className="mb-3">
                                                     <span className="event-ongoing-badge">
                                                       <span className="ongoing-radar-dot"></span>
                                                       Ongoing Event
                                                     </span>
                                                 </div> :
                                                 null
                                                 }
                                                 <div className="event-card-btn-wrap">
                                                   <Link to={"/event-details?eventid=" + eventData.events_id}
                                                       className='btn btn-danger btn-sm'
                                                       style={{ textDecoration: 'none', color: '#135592', border: '1px solid red', borderRadius: '4px', backgroundColor: 'transparent', width: '100%', padding: '8px' }} reloadDocument>Event Details</Link>
                                                 </div>
                                             </div>
                                         </div>
                                     </Col> : null
                                }
                                </React.Fragment>
                            );
                        })
                    }
                    {
                    events && events.length > 0 && events.map((eventData, index) => {
                        return (
                        <React.Fragment key={index}>
                        {eventData.events_title === '' ?
                        <Col md={12}>
                        <Card id="deptcard" className="p-4 text-center">
                            <Card.Body>
                                <Card.Title>
                                    No Event For Now
                                </Card.Title>
                            </Card.Body>
                        </Card>
                        </Col> : null
                        } 
                        </React.Fragment>
                        );
                     })
                    }
                </Row>


            </Container>

            <br></br><br></br>



        </div >
    )
}
